import ReactDOM from 'react-dom'

// Create a React 17 compatible createRoot shim
export function createRoot(container) {
  return {
    render(element) {
      ReactDOM.render(element, container)
    },
    unmount() {
      ReactDOM.unmountComponentAtNode(container)
    },
  }
}
